'use client'

import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useNavigation } from '@/lib/context/navigationcontext'
import React, { useState } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import LeftNavMobile from './leftNavMobile'
import LeftNavDesk from './leftNavDesk'
import LogoutPopup from './LogoutPopup'
import { NavIds } from './nav'

export default function LeftNav() {
	const theme = useTheme()

	const { initialLogin } = useNavigation()
	const router = useRouter()
	const pathname = usePathname()

	const isMobileScreen = useMediaQuery(theme.breakpoints.only('xs'))
	const [open, setOpen] = useState(false)

	const [isTncSelected, setIsTncSelected] = useState(false)

	const navItemSx = (selected: boolean) => ({
		'&:hover, &:active, &:disabled': {
			'backgroundColor': theme.palette.interaction.navHoverOpacity,
			'&::before': {
				display: 'none',
			},
		},
		'&:active': {
			backgroundColor: theme.palette.interaction.navActiveOpacity,
		},
		'&:disabled': {
			backgroundColor: theme.palette.interaction.disabledOpacity,
		},
		'&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:active': {
			backgroundColor: selected ? theme.palette.action.selected : undefined,
		},
		'&:focus-visible': {
			border: '2px solid',
			borderColor: theme.palette.common.black,
		},
	})

	// Set isTncSelected true if url has 'termsandconditions'
	React.useEffect(() => {
		const isTnc = pathname.includes('termsandconditions')
		setIsTncSelected(isTnc)
	}, [pathname])

	const changeFeaturePage = (navId: NavIds) => {
		switch (navId) {
			case NavIds.BusinessIntelligence:
			case NavIds.BI:
				router.push('/feature/dashboard')
				break
			case NavIds.Recruiting:
				router.push('/feature/recruiting/pipeline')
				break
			case NavIds.AgentManagement:
				router.push('/feature/agentmanagement')
				break
			case NavIds.Feedback:
				router.push('/feature/feedback')
				break
			case NavIds.Signout:
				setOpen(true)
				break
			default:
				router.push('/')
				break
		}
	}

	const handleLogoutPopupClose = () => {
		setOpen(false)
	}

	return (
		<>
			<LogoutPopup
				isOpen={open}
				onClose={handleLogoutPopupClose}
				analyticsEventName="BI Logout From LHN menu"
				from="leftNav"
			/>

			{isMobileScreen && initialLogin === false && (
				<LeftNavMobile
					setOpen={setOpen}
					changeFeaturePage={changeFeaturePage}
					isTncSelected={isTncSelected}
					setIsTncSelected={setIsTncSelected}
					navItemSx={navItemSx}
				/>
			)}

			{!isMobileScreen && (
				<LeftNavDesk
					setOpen={setOpen}
					changeFeaturePage={changeFeaturePage}
					isTncSelected={isTncSelected}
					setIsTncSelected={setIsTncSelected}
					navItemSx={navItemSx}
				/>
			)}
		</>
	)
}
